import { HttpErrorResponse } from '@angular/common/http';

const ANONYMOUS_AUTH_REJECTION_REASON = 'anonymous-auth-rejection';

// Синтетический 401: AuthInterceptor отклоняет запрос анонима, не отправляя его в сеть.
// Внешний auth уже показан, поэтому такие ошибки ожидаемы и не должны логироваться.
export function createAnonymousAuthRejection(url: string): HttpErrorResponse {
  return new HttpErrorResponse({
    status: 401,
    statusText: 'Unauthorized',
    url,
    error: { reason: ANONYMOUS_AUTH_REJECTION_REASON },
  });
}

export function isAnonymousAuthRejection(error: unknown): boolean {
  if (!(error instanceof HttpErrorResponse)) {
    return false;
  }

  const payload: unknown = error.error;

  return (
    typeof payload === 'object' &&
    payload !== null &&
    'reason' in payload &&
    payload.reason === ANONYMOUS_AUTH_REJECTION_REASON
  );
}
